(function() {
    //BTOCSITE-109320 고객지원 > 출장서비스 > AI 소음 진단 (냉장고) 팝업 메시지 개선
    var aiNoise = {
        init: function() {
            var self = this;
            //BTOCSITE-106073 고객지원 > 출장서비스 > AI 소음 진단 (냉장고)
            var $context = $(document);
            self.$noisePopup = $context.find("#aiNoiseAnalysisPopup");

            if(self.$noisePopup.length < 0) return;

            self.noiseErrorCnt = 0;
            self.$noisePopup.on('modalshow', function(){
                self.setGuideImage();
            });
            self.$noisePopup.off('change').on('change', '#noiseMovFile', function(e) {

                var $this = $(this);
                var $opener = $context.find("[data-href='#aiNoiseAnalysisPopup']");
                var $popup = self.$noisePopup;
                var url = $popup.data('ajax');
                var formData = new FormData();
                var noiseFile = document.querySelector("#noiseMovFile").files[0] || '';
                var uploadSize = document.querySelector("#noiseMovFile").files[0].size;
                var mb = 1024 * 1024 //1mb
                var limitSize = mb * 10;
                var formatType= 'mp4|mov|m4a|mp3|wav';
                var formatTypeArr = formatType.split('|');
                var formatArr = noiseFile.name.split('.');
                var format = formatArr[formatArr.length - 1].toLowerCase();
                var regex = /[?!,.&^~]/;
                var fileName = noiseFile.name.substring(0, noiseFile.name.lastIndexOf("."));
                var alertMsg = {};
                var mktModelCd = $popup.data('modelCode'); //메인 modelCode

        
                if (!vcui.array.has(formatTypeArr, format)) {
                    //확장자 아닌 경우
                    $this.val('');
                    $popup.vcModal('hide');
                    
                    alertMsg = {
                        title: 'mp4, mov, m4a, mp3, wav 파일만 첨부 가능합니다.',
                        okBtnName: '확인',
                    }
                    self.showModalForNoise('ALERT', alertMsg, $opener);
        
                    return;
                }
        
                if(regex.test(fileName)){
                    //특수문자
                    $this.val('');
                    $popup.vcModal('hide');
        
                    alertMsg = {
                        title: '파일명에는 특수기호(? ! , . & ^ ~)를 사용할 수 없습니다.',
                        okBtnName: '확인',
                    }
                    self.showModalForNoise('ALERT', alertMsg, $opener);
                    return;
                }
                
                if(limitSize <= uploadSize){
                    //10M 넘어가는 경우
                    $this.val('');
                    $popup.vcModal('hide');
        
                    alertMsg = {
                        title: '10M 이하의 파일만 업로드가 가능합니다.',
                        okBtnName: '확인',
                    }
                    self.showModalForNoise('ALERT', alertMsg, $opener);
                    return;
                }

        
                if(noiseFile != ''){
                    //BTOCSITE-115195 고객지원 > AI 소음진단 음원 저장 요청
                    if($('.support').hasClass('service-engineer')){ //출장 only
                        formData.append('lockUserId', $context.find('#lockUserId').val());
                    }
                    if($('.support').hasClass('service-engineer') || $('.support').hasClass('online-service')){ //출장, 상담
                        formData.append('sympCd', $context.find('#sympCd').val());
                        formData.append('sympSubCode', $context.find('#sympSubCode').val());
                        formData.append('sympCodeThree', $context.find('#sympCodeThree').val());
                        formData.append('productCode', $context.find('#productCode').val());
                    }
                    if($('.support').hasClass('support-home')){ //메인 보유제품
                        formData.append('productCode', $popup.data('productCode') || '');
                    }

                    formData.append('file', noiseFile);
                    $this.val(''); //value값 삭제
        
                    lgkorUI.showAiLoading('#aiNoiseAnalysisPopup');
                    lgkorUI.requestAjaxFileData(url, formData, function(result) {
                        var data = result.data; 

                        if(mktModelCd){
                            data.url_engi = "/support/service-engineer-reservation?mktModelCd="+mktModelCd; //출장
                            data.url_call = "/support/request-call-reservation?mktModelCd="+mktModelCd; //삼당
                        }else{
                            data.url_engi = "/support/service-engineer-reservation"; //출장
                            data.url_call = "/support/request-call-reservation"; //삼당
                        }
                        var qnaId = self.isDryer() ? '20151815914412' : '20153605102607'; //건조기, 냉장고 스스로해결
                        data.url_qna = "/support/solutions-" + qnaId + "?utm_source=solution&utm_medium=popup&utm_campaign=ai";

                        if($('.support').hasClass('support-home')){
                            
                            data.curr_page = "home";//메인
                        }else if($('.support').hasClass('service-engineer')){
                            
                            data.curr_page = "engi";//출장
                        }else if($('.support').hasClass('online-service')){
                        
                            data.curr_page = "call"; //상담
                        }
        
                        if(data.result == "ERROR"){
                            //ERROR
                            if(self.noiseErrorCnt < 1) {
                                data.AI_result = "ERROR";
                                self.noiseErrorCnt = 1;
                            }else{
                                data.AI_result = "RETRY"; //재시도
                            }
        
                            self.showModalForNoise('POPUP', data, $opener);
        
                        }else if(data.AI_result == "NG"){
                            //불량소음
                            if(data.AI_result == '') {
                                data.AI_result = "ERROR";
                            }else{
                                if(self.isDryer()){
                                    $.extend(data, self.getDryerNoiseDesc(data.AI_result, data.AI_desc));
                                }else{
                                    $.extend(data, self.getAiNoiseDesc(data.AI_result, data.AI_desc_kr));
                                }
                            }
        
                            self.showModalForNoise('POPUP', data, $opener);
                            
                        }else if(data.AI_result == "OK"){
                            //정상소음
                            if(Number(data.SPL) < 30) {
                                data.AI_result = "DOWN"; //30dB 이하
                            }else{
                                if(String(data.AI_desc).toLowerCase() === "normal"){
                                    data.AI_result = "UP";  //30dB 이상
                                }
                            }
                            var commonDesc = self.getCommonNoiseDesc(data.AI_result);
                            if(commonDesc){
                                $.extend(data, commonDesc);
                            }else if(self.isDryer()){
                                $.extend(data, self.getDryerNoiseDesc(data.AI_result, data.AI_desc));
                            }else{
                                $.extend(data, self.getAiNoiseDesc(data.AI_result, data.AI_desc_kr));
                            }
                            self.showModalForNoise('POPUP', data, $opener);
                        }
                        //BTOCSITE-115195 고객지원 > AI 소음진단 음원 저장 요청
                        if($('.support').hasClass('service-engineer')){
                            $context.find('[name=aiNoiseFlag]').val('Y');
                        }
                                    
                        lgkorUI.hideAiLoading('#aiNoiseAnalysisPopup');
                        $popup.vcModal('hide');
        
                    }, 'POST', '', '', function(err){
                        lgkorUI.alert("", { title: "오류발생"});
                        lgkorUI.hideAiLoading('#aiNoiseAnalysisPopup');
                    });
                }
            });
        
        },
        // 팝업 이미지 변경(건조기, 냉장고)
        setGuideImage: function(){
            var $img = this.$noisePopup.find('.img-wrap img');
            if(this.isDryer()){
                $img.attr({
                    src: '/lg5-common/images/CS/img_dryer_noise_analysis.png',
                    alt: '건조기 정면 중앙에 휴대폰 하단 마이크를 위치 시키세요.'
                });
            }else{
                $img.attr({
                    src: '/lg5-common/images/CS/img_fridge_noise_analysis.png',
                    alt: '냉장고 정면 중앙 높이에서 50cm 간격을 두고 녹음해 주세요.'
                });
            }
        },
        // 건조기인지 확인
        isDryer: function(){
            var popupData = (this.$noisePopup && this.$noisePopup.data()) || {};
            var subCate = String($('#subCategory').val() || popupData.subCategory || '').replace(/\s/g, '');
            return subCate === 'CT50019275';
        },
        // 30dB 이하/이상. 냉장고, 건조기 공통
        getCommonNoiseDesc: function(result){
            if(result === 'DOWN'){
                return {
                    notice: "고객님,<br>"+
                    "업로드해 주신 파일의 소리가 조용한 사무실이나 도서관 정도의 소리인 30dB 보다도 더 조용하게 나오고 있어요.<br><br>"+
                    "이건 제품이 정상적으로 잘 작동하고 있다는 뜻이니까 걱정하지 마시고 편하게 사용해 주세요!.<br></br>"+
                    "더 자세한 설명이 필요하시면 [소음 Q&A]를,<br>"+
                    "그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.",
                }
            }
            if(result === 'UP'){
                return {
                    notice: "고객님, 보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 제품이 열심히 일할 때 나는 정상적인 소리 였어요.<br><br>"+
                    "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다.<br>"+
                    "안심하고 편안하게 사용하세요!<br><br>"+
                    "더 자세한 설명이 필요하시면 [소음 Q&A]를,<br>"+
                    "그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.",
                }
            }
        },
        // 냉장고
        getAiNoiseDesc: function(result, type){
            var notice = '';
        
            switch (type){
                case '컴프': 
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 냉장고가 시원한 냉기를 만들 수 있도록 컴프레서가 잠시 '웅-' 하고 힘을 내는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를,<br>"+
                        "그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 냉장고의 심장과 같은 컴프레서(압축기)에서 나는 소리였어요.<br><br>"+
                        "냉장고를 시원하게 만들어주는 아주 중요한 부품인데, 평소와는 조금 다른 소리가 들리는 것 같아요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }
        
                    return {
                        notice: notice,
                        term_title: "컴프레서란?",
                        term_desc: "냉장고 안을 시원하게 만들기 위해 냉매를 압축해 순환시키는 중요한 부품입니다.<br><br>작동할 때는 일정한 패턴의 ‘웅’ 소리가 나며, 주기적으로 켜졌다 꺼집니다.",
                    }
                
                case '기계실':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 냉장고의 기계실에서 여러 부품들이 힘을 합쳐 시원함을 만들 때 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를,<br>"+
                        "그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 냉장고의 중요한 부품들이 모여있는 '기계실' 쪽에서 나는 소리 같아요.<br><br>"+
                        "여러 부품 중 하나가 점검이 필요한 신호를 보내는 것일 수 있으니, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }
                    
                    return {
                        notice: notice,
                        term_title: "기계실이란?",
                        term_desc: "냉장고의 핵심 부품인 컴프레서를 포함하여 순환팬, 열교환기 등이 배치된 공간입니다.<br><br>"+
                        "각 부품이 작동할 때는 일정한 패턴의 소리가 발생합니다.",
                    }

                case '팬모터':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 냉장고 속 시원한 공기를 구석구석 보내주기 위해 ‘팬모터’가 팬을 열심히 돌리는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를,<br>"+
                        "그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 보내주신 소리는 시원한 바람을 만들어주는 '팬'을 돌리는 '팬 모터'에서 나는 소리였어요.<br><br>"+
                        "그런데 모터가 평소와는 다르게 조금 힘들어하는 소리로 들리고 있어요.<br><br>"+
                        "소리가 더 커지기 전에,[상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }
                    
                    return {
                        notice: notice,
                        term_title: "팬모터란?",
                        term_desc: "바람개비처럼 생긴 날개 모양의 팬을 돌려 냉장/냉동실을 시원하게 해주는 모터 부품입니다.<br><br>"+
                        "작동할 때는 일정한 패턴의 ‘윙~’ 소리가 나며, 내부 온도에 따라 빠르게 또는 약하게 작동합니다.",
                    }

                case '아이스메이커':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 ‘아이스 메이커’에서 시원한 얼음을 얼리고, 다 만들어진 얼음을 '톡' 하고 밀어낼 때 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를,<br>"+
                        "그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 시원한 얼음을 만들어주는 '아이스 메이커'에서 나는 소리였어요.<br><br>"+
                        "그런데 얼음이 만들어지는 과정에서 무언가 살짝 불편한 부분이 있는 것 같아요.<br><br>"+
                        "고객님께서 언제나 시원한 얼음을 즐기실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }
                    
                    return {
                        notice: notice,
                        term_title: "아이스메이커란?",
                        term_desc: "냉장고에서 얼음을 만들어주는 부품으로 트레이와 모터 등으로 구성되어 있습니다.<br><br>"+
                        "작동할 때는 모터가 돌아가는 소리나 얼음이 완성되어 떨어지는 소리가 주기적으로 발생합니다.",
                    }

                case '냉매음':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 냉장고를 시원하게 만들어주는 ‘냉매’가 흐르면서 나는 '꾸르륵' 또는 '쏴아-' 하는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를,<br>"+
                        "그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 냉장고 속을 시원하게 만들어주는 '냉매'가 흐르면서 나는 소리였어요.<br><br>"+
                        "평소에 들리는 '쪼르륵'하는 소리와는 다른, 조금 낯선 소리로 확인되고 있어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }
                    
                    return {
                        notice: notice,
                        term_title: "냉매란?",
                        term_desc: "냉매 가스는 냉장고 배관을 순환하며 주변 열을 흡수해 냉동과 냉장이 이루어지도록 합니다.<br><br>"+
                        "순환할 때 기체에서 액체, 액체에서 기체 등으로 가스 상태가 변화하면서 간헐적으로 소리가 날 수 있습니다.",
                    }

                case '팬소음':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 냉장고 안의 시원한 공기를 골고루 보내주기 위해 '팬'이 잠시 돌아가는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를,<br>"+
                        "그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 시원한 공기를 냉장고 구석구석 보내주는 '팬'에서 나는 소리였어요.<br><br>"+
                        "그런데 팬이 조금 힘겹게 도는 듯한 소리로 확인되었어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }
                    
                    return {
                        notice: notice,
                        term_title: "팬이란?",
                        term_desc: "팬 모터에 장착된 바람개비처럼 생긴 날개로 냉장/냉동실을 시원하게 해주는 부품입니다.<br><br>"+
                        "작동할 때는 일정한 패턴의 ‘윙~’ 소리가 나며, 내부 온도에 따라 빠르게 또는 약하게 작동합니다.",
                    }

            }
        
        },
        // 건조기
        getDryerNoiseDesc: function(result, type){
            var notice = '';

            switch (type){
                case 'Roller':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 드럼을 받쳐주는 '롤러'에서 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "장시간 사용하지 않다가 처음 작동할 때는 롤러의 고무가 눌려 있어 ‘둥둥’ 소리가 날 수 있으며, 일정 시간 작동하면 고무가 원래 상태로 돌아오면서 소리가 줄어들어요. 다만, 제품의 수평이 맞지 않으면 소음이 크게 느껴질 수 있으니 수평 상태를 확인하여 제품이 흔들리지 않게 해주세요.<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를, 그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 드럼을 받쳐주는 '롤러'에서 나는 소리였어요.<br><br>"+
                        "그런데 롤러가 조금 힘겹게 도는 듯한 소리로 확인되었어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }

                    return {
                        notice: notice,
                        term_title: "롤러란?",
                        term_desc: "건조기 안쪽 통이 부드럽게 돌아가도록 받쳐주는 부품입니다.<br><br>"+
                        "건조기를 사용하지 않는 동안 드럼을 받치는 롤러의 고무가 눌려 있다가 다시 펴지면서 ‘둥둥’ 소리가 나는 건 자연스러운 현상이에요.",
                    }

                case 'Bearing':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 드럼이 원활하게 회전하도록 돕는 ‘베어링’에서 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "건조기 베어링에 사용되는 윤활유는 회전하는 고온 환경에서도 오래 유지되는 전용 윤활유이며, 부품을 보호하고 소음 및 마모를 줄여줘요. 제품 작동 후 일정 시간이 지나면 윤활유가 고르게 퍼지면서 소음이 줄어들고 원활하게 작동해요.<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를, 그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 드럼이 원활하게 회전하도록 돕는 ‘베어링’에서 나는 소리였어요.<br><br>"+
                        "그런데 베어링에서 나는 소리가 조금 큰 것으로 확인되었어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }

                    return {
                        notice: notice,
                        term_title: "드럼 베어링이란?",
                        term_desc: "볼 베어링 적용 모델에서는 건조기 안쪽 통이 흔들리지 않고 원활하게 돌아가도록 잡아주며, 감속기 적용 모델에서는 건조기 통이 알맞은 속도로 회전하도록 조절해 주는 부품입니다.<br><br>"+
                        "베어링이 일부 마모되거나 내부 윤활유가 굳으면 소리가 날 수 있어요.",
                    }

                case 'Pump':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기의 물을 빼주는 ‘배수 펌프’에서 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "배수 방식에 따라 물통에 물이 채워지는지 또는 배수 호스로 물이 배출되는지 확인해 보세요. 물이 정상적으로 채워지거나 배출된다면 제품이 정상적으로 작동하는 것이므로 안심하고 사용해 주세요.<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를, 그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기의 물을 빼주는 ‘배수 펌프’에서 나는 소리였어요.<br><br>"+
                        "그런데 배수 펌프가 조금 힘겹게 작동하는 듯한 소리로 확인되었어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }

                    return {
                        notice: notice,
                        term_title: "배수 펌프란?",
                        term_desc: "건조 과정에서 생긴 물을 밖으로 빼주는 부품입니다.<br><br>"+
                        "건조 중에 생긴 물을 끌어 올려 콘덴서를 자동으로 세척하거나 물을 배출하는 과정에서 소리가 발생할 수 있으며, 30초에서 최대 3분까지 지속될 수 있어요.",
                    }

                case 'Comp':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 내부를 따뜻하게 만드는 ‘컴프레서’에서 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "제품 작동 초반에는 내부 온도를 높이기 위해 컴프레서의 소리가 커질 수 있지만, 일정 시간이 지나 온도가 올라가면 소리가 자연스럽게 줄어들어요.<br><br>"+
                        "또, 제품의 수평이 맞지 않으면 진동으로 인해 소음이 발생할 수 있어요. 스패너를 이용해 높이가 낮은 쪽의 높이 조절 나사를 돌려 제품이 흔들리지 않도록 수평을 맞춰 주세요.<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를, 그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 내부를 따뜻하게 만드는 ‘컴프레서’에서 나는 소리였어요.<br><br>"+
                        "그런데 컴프레서가 조금 힘겹게 작동하는 듯한 소리로 확인되었어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }

                    return {
                        notice: notice,
                        term_title: "컴프레서란?",
                        term_desc: "건조에 필요한 따뜻한 바람을 만드는 부품입니다.<br><br>"+
                        "추운 날씨나 주변 온도가 낮을 땐 온도를 빨리 높이기 위해 더 빠르게 회전하므로 소리가 커질 수 있어요.",
                    }

                case 'Fan':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 ‘팬’이 회전하며 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "해당 소리는 건조기 내부 열기를 순환시키기 위한 정상적인 팬 작동음이에요. 팬이 원활하게 작동할 수 있도록 필터를 주기적으로 청소해 먼지가 쌓이지 않도록 관리해 주세요.<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를, 그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 ‘팬’이 회전하며 나는 소리였어요.<br><br>"+
                        "그런데 팬이 조금 힘겹게 도는 듯한 소리로 확인되었어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }

                    return {
                        notice: notice,
                        term_title: "팬이란?",
                        term_desc: "건조기 안의 공기가 잘 순환하도록 바람을 보내주는 부품입니다.<br><br>"+
                        "내부 열기를 골고루 퍼뜨리기 위해 팬 모터가 회전하면서 ‘웅~’ 하는 선풍기 소리 또는 ‘윙~’ 하는 바람 소리가 날 수 있어요.",
                    }

                case 'Damping':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 드럼의 균형을 맞추기 위해 부착된 ‘댐핑 시트’에서 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "세탁물을 모두 꺼낸 후 빈 통으로 제품을 작동해 소리를 확인해 보세요. 세탁물의 단추, 지퍼, 장식물 등이 드럼에 부딪히며 ‘탁탁’ 소리를 낼 수 있으므로 확인이 필요해요.<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를, 그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 드럼의 균형을 맞추기 위해 부착된 ‘댐핑 시트’에서 나는 소리였어요.<br><br>"+
                        "그런데 댐핑 시트가 조금 힘겹게 작동하는 듯한 소리로 확인되었어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }

                    return {
                        notice: notice,
                        term_title: "댐핑 시트란?",
                        term_desc: "건조 중 빨래가 부딪힐 때 발생하는 소음과 충격을 줄여주는 고무 재질의 부품입니다.<br><br>"+
                        "댐핑 시트가 일부 떨어지면 작동 중 소리가 날 수 있어요.",
                    }

                case 'Drum_motor':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 드럼을 회전시키는 ‘모터’에서 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "모터 작동음은 드럼이 회전할 때 ‘웅~’, ‘윙~’ 하는 일정한 소리로 들릴 수 있어요. 소음을 줄이기 위해 세탁물을 적정량 넣고, 제품이 작동 중 흔들리지 않도록 수평 상태를 확인해 주세요.<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를, 그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 드럼을 회전시키는 ‘모터’에서 나는 소리였어요.<br><br>"+
                        "그런데 모터가 조금 힘겹게 도는 듯한 소리로 확인되었어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }

                    return {
                        notice: notice,
                        term_title: "드럼 모터란?",
                        term_desc: "건조기 안쪽 통을 돌려주는 부품입니다.<br><br>"+
                        "드럼 회전 중 소리가 날 수 있으며, 제품의 정상적인 작동 중 나타나는 자연스러운 현상이에요.",
                    }

                case 'Cabinet':
                    if(result === 'OK'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 케이스인 ‘캐비닛’이 맞닿는 부분에서 나는 소리였어요.<br><br>"+
                        "고장이나 문제가 있을 때 나는 소리는 아니니 걱정하지 않으셔도 괜찮습니다. 안심하고 편안하게 사용하세요!<br><br>"+
                        "제품이 흔들리지 않도록 수평을 맞추고, 건조기에 주변 벽이나 물건, 배수 호스 등이 닿아 있지 않은지 확인해 주세요. 또한 상판 위에 물건이 올려져 있다면 모두 치운 후 다시 작동해 소음이 줄어드는지 확인해 보세요.<br><br>"+
                        "더 자세한 설명이 필요하시면 [소음 Q&A]를, 그래도 소리가 계속 신경 쓰이신다면 [상담 예약]을 통해 도움을 받으실 수 있습니다.";
                    }else if(result === 'NG'){
                        notice = "고객님,<br>"+
                        "보내주신 소리를 인공지능으로 꼼꼼히 들어보니, 이 소리는 건조기 케이스인 ‘캐비닛’이 맞닿는 부분에서 나는 소리였어요.<br><br>"+
                        "그런데 캐비닛이 닿으며 들리는 소리가 조금 큰 것으로 확인되었어요.<br><br>"+
                        "고객님께서 안심하고 제품을 사용하실 수 있도록, [상담 예약]을 통해 소음 문제 해결을 도와드리겠습니다. 필요 시 [출장 예약]으로 전문가의 점검도 받아보실 수 있습니다.";
                    }

                    return {
                        notice: notice,
                        term_title: "캐비닛이란?",
                        term_desc: "건조기 외부를 감싸고 있는 본체 케이스입니다.<br><br>"+
                        "건조기 작동 중 진동으로 떨림이 발생하면서 소리가 발생할 수 있어요.",
                    }

            }
        },

        showModalForNoise: function(type, obj, opener){
            var self = this;
            var noiseTmpl = 
                '<article id="aiNoiseResultPopup" class="popup-wrap">'+
                    '<header class="pop-header">'+
                    '<h4 class="tit"><span>AI로 소음 진단하기</span></h4>'+
                    '</header>'+
                    '<section class="pop-conts common-pop">'+
                        '<div class="ai-noise-result">'+
            
                            '{{# if (AI_result == "DOWN") { #}}' +
                                '<h5 class="title-5">AI 분석결과,<br>해당 소리는 정상 작동음입니다.</h5>'+
                                '<div class="txt-box">{{#raw notice}}</div>'+
            
                                '<h6 class="title-6">소리 레벨 분석 결과</h6>'+
                                '<div class="db-lebel-area db">'+
                                    '<p class="text">'+
                                        '<span class="blind">데시벨 : </span>'+
                                        '<span>{{SPL}}</span>'+
                                    '</p>'+
                                '</div>'+

                            '{{# } else if (AI_result == "UP") { #}}' +
                                '<h5 class="title-5">AI 분석결과,<br>해당 소리는 정상 작동음입니다.</h5>'+
                                '<div class="txt-box">{{#raw notice}}</div>'+
            
                                '<h6 class="title-6">AI 소음 판정 결과 : 정상범주</h6>'+
                                '<p class="sub-title">소음이 아닌 제품 작동음으로 감지됐어요.</p>'+
            
                                '<div class="db-lebel-area ok">'+
                                    '<span class="blind">정상 데시벨</span>'+
                                '</div>'+
                            
                            '{{# } else if (AI_result == "OK") { #}}' +
                                '<h5 class="title-5">AI 분석결과,<br>해당 소리는 정상 작동음입니다.</h5>'+
                                '<div class="txt-box">{{#raw notice}}</div>'+
            
                                '<h6 class="title-6">AI 소음 판정 결과 : 정상범주</h6>'+
                                '<p class="sub-title">소음이 아닌 제품 작동음으로 감지됐어요.</p>'+
            
                                '<div class="db-lebel-area ok">'+
                                    '<span class="blind">정상 데시벨</span>'+
                                '</div>'+
            
                                '<dl class="desc-box">'+
                                    '<dt>{{#raw term_title}}</dt>'+
                                    '<dd>{{#raw term_desc}}</dd>'+
                                '</dl>'+
                                
                            '{{# } else if (AI_result == "NG") { #}}' +
                                '<h5 class="title-5">AI 분석결과,<br>'+
                                    '전문가의 점검이 필요한 소리로 확인됩니다.</h5>'+
                                '<div class="txt-box">{{#raw notice}}</div>'+
            
                                    
                                '<h6 class="title-6">AI 소음 판정 결과 : 점검필요</h6>'+
                                '<p class="sub-title">제품에서 이상 소음이 감지됐어요.</p>'+
            
                                '<div class="db-lebel-area ng">'+
                                    '<span class="blind">불량 데시벨</span>'+
                                '</div>'+
            
                                '<dl class="desc-box">'+
                                    '<dt>{{#raw term_title}}</dt>'+
                                    '<dd>{{#raw term_desc}}</dd>'+
                                '</dl>'+
            
                            '{{# } else if (AI_result == "ERROR") { #}}' +
                            
                                '<div class="error-wrap">'+
                                    '<h5 class="title-5">정확한 분석을 위해 <br>'+
                                        '녹음 파일을 다시 확인해 주세요.</h5>'+
                                '</div>'+
                                '<div class="txt-area">'+
                                    '첨부해 주신 음원으로 분석을 완료하지 못했습니다.<br>'+
                                    '확실한 진단을 위해 소리가 선명하게 녹음된 파일이 필요합니다.<br><br>'+
                                    '아래 안내를 참고해 다시 녹음해 주시면 더 정확한 결과를 받아보실 수 있습니다.'+
                                '</div>'+
                                '<ul class="bullet-list">'+
                                    '<li class="b-txt">녹음 시간은 5~9초 정도로 충분히 녹음해 주세요.</li>'+
                                    '<li class="b-txt">{{product_nm}} 정면 중앙 높이에서 50cm 간격을 두고 녹음해 주세요.</li>'+
                                '</ul>'+
            
                            '{{# } else if (AI_result == "RETRY") { #}}' +
                            
                                '<div class="error-wrap">'+
                                    '<h5 class="title-5">AI 소음 분석이 <br>'+
                                        '완료되지 않았습니다.</h5>'+
                                '</div>'+
                                '<div class="txt-area">'+
                                    '고객님, 죄송합니다.<br>'+
                                    '첨부해 주신 녹음 파일로는 분석을 완료할 수 없습니다.<br>'+
                                    '소음이 또렷하게 녹음되지 않으면 AI가 소리를 판별하기 어렵습니다.<br><br>'+
                                    '분석에 어려움이 있으시다면 소음 Q&A를 이용해 보세요. 소음 Q&A에서 비슷한 소음을 들어보고 {{product_nm}}에서 나는 소음이 어떤 유형인지 직접 확인해 보세요.<br><br>'+
                                    '만약 불편함이 계속된다면 출장 서비스 예약을 통해 전문가의 점검을 받아보실 수 있습니다.'+
                                '</div>'+

                            '{{# } #}}'+

                            // 메인
                            '{{# if ((AI_result == "DOWN" || AI_result == "UP" || AI_result == "OK" || AI_result == "RETRY") && (curr_page == "home")) { #}}' +
                                '<div class="btn-group">'+
                                    '<a href="{{url_engi}}" class="btn-link">출장 서비스 예약이 필요하신가요?</a>'+
                                    '<a href="{{url_call}}" class="btn-link">전문가의 상담이 필요하신가요?</a>'+
                                '</div>'+
                            
                            //출장
                            '{{# } else if ((AI_result == "DOWN" || AI_result == "UP" || AI_result == "OK" || AI_result == "RETRY") && (curr_page == "engi")) { #}}' +
                                '<div class="btn-group">'+
                                    '<button type="button" class="btn-link ui_modal_close"><span>출장 서비스 예약이 필요하신가요?</span></button>'+
                                    '<a href="{{url_call}}" class="btn-link">전문가의 상담이 필요하신가요?</a>'+
                                '</div>'+
                            //상담
                            '{{# } else if ((AI_result == "DOWN" || AI_result == "UP" || AI_result == "OK" || AI_result == "RETRY") && (curr_page == "call")) { #}}' +
                                '<div class="btn-group">'+
                                    '<a href="{{url_engi}}" class="btn-link">출장 서비스 예약이 필요하신가요?</a>'+
                                    '<button type="button" class="btn-link ui_modal_close"><span>전문가의 상담이 필요하신가요?</span></button>'+
                                '</div>'+
                            
                            // 메인, 상담
                            '{{# } else if (AI_result == "NG" && (curr_page == "home" || curr_page == "call")) { #}}' +
                                '<div class="btn-group">'+
                                    '<a href="{{url_engi}}" class="btn-link">출장 서비스 예약이 필요하신가요?</a>'+
                                    '<a href="{{url_qna}}" class="btn-link">소음 종류와 해결 방법을 알고 싶으신가요?</a>'+
                                '</div>'+

                            // 출장
                            '{{# } else if (AI_result == "NG" && curr_page == "engi") { #}}' +
                                '<div class="btn-group">'+
                                    '<a href="{{url_call}}" class="btn-link">전문가의 상담이 필요하신가요?</a>'+
                                    '<a href="{{url_qna}}" class="btn-link">소음 종류와 해결 방법을 알고 싶으신가요?</a>'+
                                '</div>'+
                            '{{# } #}}'+

                        '</div>'+  
                    '</section>'+
                    '<footer class="pop-footer center">'+
                    '<div class="btn-group">'+
                        '{{# if (AI_result == "OK" || AI_result == "UP"|| AI_result == "RETRY" || AI_result == "DOWN") { #}}' +
                            '<a href="{{url_qna}}" class="btn pink"><span>소음 Q&A 바로가기</span></a>'+

                        '{{# } else if (AI_result == "NG" && curr_page == "home") { #}}' +
                            '<a href="{{url_call}}" class="btn pink"><span>상담 예약 바로가기</span></a>'+
            
                        '{{# } else if (AI_result == "NG" && curr_page == "call") { #}}' +
                            '<button type="button" class="btn pink ui_modal_close"><span>상담 예약 바로가기</span></button>'+

                        '{{# } else if (AI_result == "NG" && curr_page == "engi") { #}}' +
                            '<button type="button" class="btn pink ui_modal_close"><span>출장 서비스 예약 바로가기</span></button>'+
                        
                        '{{# } else if (AI_result == "ERROR") { #}}' +
                            '<button type="button" class="btn pink ui_modal_close"><span>확인</span></button>'+
            
                        '{{# } #}}'+
                    '</div>'+
                    '</footer>'+
                    '<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>'+
                '</article>';

        
            if($('#aiNoiseResultPopup').length > 0){
                $('#aiNoiseResultPopup').remove();
            }
        
            switch (type){
                case 'POPUP':
                    // ERROR/RETRY: 냉장고 / 건조기
                    obj.product_nm = self.isDryer() ? '건조기' : '냉장고';
                    var html = vcui.template(noiseTmpl, obj);
                    self.$noisePopup.after(html);
                    $('#aiNoiseResultPopup').vcModal({opener:opener});
                    $('#aiNoiseResultPopup').find('.pop-conts').animate({ scrollTop: 0 }, 500);
                
                break;
                case 'ALERT':

                    lgkorUI.alert('', obj, opener);  
        
                break;
            }
        },
    }

    $(window).ready(function() {
        aiNoise.init();
    });
})();